import { render } from "./InvoiceManager.vue?vue&type=template&id=67e9d632&scoped=true"
import script from "./InvoiceManager.vue?vue&type=script&lang=js"
export * from "./InvoiceManager.vue?vue&type=script&lang=js"

import "./InvoiceManager.vue?vue&type=style&index=0&id=67e9d632&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e9d632"]])

export default __exports__